import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import axios from "axios";

import HomePageSettingMenu from "../common/homepageSettingMenu";
import RegisterMenu from "./registerMenu";
import ImageUploadAdapterPlugin from "../../../../../utils/ImageUploadAdapter";
import { RegisterPhotoUploadFormContainer } from "../styled/register";
import HomepageNotice from "../common/homepageNotice";

import { noticeMessages } from "../common/function/noticeMessages";
import { setRegisterIndex } from "../../../../../store/compoIndex";
import { useModal } from "../../../../../hooks/useModal";
import useUploadFiles from "../../../../../hooks/useUploadFiles";

export default function RegisterPhotoUploadForm({ fileBoxImages }) {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const companyInfo = useSelector((state) => state?.company?.companyInfo);
  const user = useSelector((state) => state?.user?.data[0]);
  const setting = useSelector((state) => state?.user?.setting);
  const index = useSelector((state) => state.compoIndex.register);

  const ckeditorInstanceRef = useRef(null);
  const { modal, openModal, closeModal } = useModal();
  const { uploadEmbedded } = useUploadFiles();

  const [cmpnyNo, setCmpnyNo] = useState();
  const [content, setContent] = useState("");
  const [title, setTitle] = useState();
  const [currentAuth, setCurrentAuth] = useState("VIEWER");

  const portNo = params.portNo;

  useEffect(() => {
    const company = JSON.parse(sessionStorage.getItem("homepageCompany"));

    if (!company) {
      navigate("/mypage");
    } else {
      setCmpnyNo(company.cmpnyNo);
      setCurrentAuth(
        companyInfo?.find?.((info) => info.cmpnyNo === company.cmpnyNo)?.auth || "VIEWER",
      );
    }

    if (portNo) getPortfolio();

    if (Array.isArray(fileBoxImages) && fileBoxImages.length > 0) {
      const imageHtml = fileBoxImages
        .map((item) => `<figure class="image"><img src="${imgHandler(item.filePath)}"></figure>`)
        .join("");
      setContent(imageHtml);
    }
  }, []);

  const getPortfolio = async () => {
    const res = await axios.post("/api/portMgmtList", {
      portNo,
      useYn: "Y",
      notitleYn: "Y",
      offset: 0,
      pageNumber: 0,
      pageSize: 12,
      paged: true,
    });
    const data = res.data.content?.[0];
    if (data) {
      setTitle(data.title);
      setContent(data.contents);
    }
  };

  const handleEditorChange = (_, editor) => {
    setContent(editor.getData());
  };

  const extractFirstImageSrc = (html) => {
    const match = html.match(/<img[^>]+src=\"([^">]+)\"/);
    return match ? match[1] : null;
  };
  const lastSubmit = async () => {
    const updatedContent = await uploadEmbedded(content);
    const imageSrc = extractFirstImageSrc(updatedContent) || "";

    const body = {
      cmpnyNo,
      notitleYn: "Y",
      title,
      contents: updatedContent,
      useYn: "Y",
      createMberId: user.userName,
      updateMberId: user.userName,
      imgUrl: imageSrc,
    };
    if (portNo) body.portNo = Number(portNo);

    try {
      const res = await axios.put("/api/portfolio", body);
      if (res.data.success) {
        toast.success(`포트폴리오가 ${portNo ? "수정" : "등록"}되었습니다.`, {
          toastId: "no-access",
        });
        navigate("/mypage/register");
        dispatch(setRegisterIndex(2));
      }
    } catch (err) {
      console.error(err);
    } finally {
      closeModal();
    }
  };

  const checkValidation = () => {
    if (!title) return toast.error("제목을 입력해 주세요.");
    if (!content) return toast.error("내용을 입력해 주세요.");
    return true;
  };

  const saveAndNext = async () => {
    if (!checkValidation()) return;
    await lastSubmit();
  };

  const moveToPage = () => {
    navigate("/mypage/register");
    dispatch(setRegisterIndex(2));
  };

  const handleEditorReady = (editor) => {
    ckeditorInstanceRef.current = editor;
    if (currentAuth === "VIEWER") {
      editor.enableReadOnlyMode("viewerMode");
    }
  };

  return (
    <>
      {modal}
      <RegisterPhotoUploadFormContainer className={setting?.mode}>
        <HomePageSettingMenu />
        <HomepageNotice message={noticeMessages[2]} />
        <RegisterMenu index={index} />
        <div className="cont">
          <input
            type="text"
            placeholder="제목을 입력하세요."
            defaultValue={title}
            onChange={(e) => setTitle(e.target.value)}
            readOnly={currentAuth === "VIEWER"}
          />
          <CKEditor
            editor={ClassicEditor}
            data={content}
            onChange={handleEditorChange}
            onReady={handleEditorReady}
            config={{
              extraPlugins: [ImageUploadAdapterPlugin],
              toolbar: ["bold", "italic", "link", "imageUpload"],
              uiSettings: { height: "500px" },
            }}
            ref={ckeditorInstanceRef}
          />
          <div className="actions">
            {currentAuth !== "VIEWER" && (
              <button onClick={() => navigate(-1)}>
                <span>취소</span>
              </button>
            )}
            {currentAuth !== "VIEWER" && (
              <button
                onClick={() =>
                  openModal({
                    isOpen: true,
                    type: "confirmation",
                    title: `포트폴리오`,
                    message: [`포트폴리오를 ${portNo ? "수정" : "등록"}하시겠습니까?`],
                    handleConfirm: saveAndNext,
                    handleCancel: closeModal,
                  })
                }>
                <span>{portNo ? "수정" : "저장"}</span>
              </button>
            )}
            <button onClick={moveToPage}>
              <span>목록</span>
            </button>
          </div>
        </div>
      </RegisterPhotoUploadFormContainer>
    </>
  );
}
